
export default function AboutData(termLengths) {
    return {
        title: "What is Traditional Long-Term Care?",
        content: 'Insurance designed to help mitigate the expense of chronic illnesses, disabilities or other conditions requiring assisted care or supervision for an extended period of time. LTC insurance may be used to help to cover the costs of in-home care, assisted living, and residence in a nursing home.',
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/traditional-long-term-care/AboutData.js